import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: 'highlight',
  standalone:true
})
export class HighlightPipe implements PipeTransform{

  transform(value: string, search: string): string {
    if (value == null) {
      return '';
    }
    const str = String(value);
    if (!search) {
      return str;
    }
    const escaped = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const pattern = new RegExp(escaped, 'gi');
    return str.replace(pattern, '<b>$&</b>');
  }
}